module.exports = __webpack_public_path__ + "assets/e840f8a1ba33ff24b625e580d938d48e.png";